import { Component, inject, input, signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import * as uuid from 'uuid';
import { IconComponent } from '@app/shared/components';
import { MenuItem } from '../../../model/menu-item';

@Component({
    selector: 'app-menu-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [RouterModule, TranslateModule, IconComponent],
})
export class MenuItemComponent {
    private readonly activatedRoute = inject(ActivatedRoute);

    readonly item = input.required<MenuItem>();

    readonly root = this.activatedRoute.root;
    readonly submenuId = `app-menu-submenu-${uuid.v4()}`;
    readonly isOpen = signal(false);

    toggle(): void {
        this.isOpen.update((v) => !v);
    }
}
